<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal modal-campaign-designation" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content" style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal">Designations</p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content" style="overflow: hidden">
                                <div class="input-search mb-5">
                                    <img src="@/assets/images/search.svg" alt="" />
                                    <input
                                        v-model="search"
                                        type="text"
                                        placeholder="Search..."
                                        @input="filter"
                                    />
                                </div>
                                <div class="d-flex flex-column" v-if="displayDesignations.length">
                                    <vue-custom-scrollbar class="scroll-area" style="width: 100%; overflow-x: hidden; max-height: 240px"
                                                          :settings="modalScrollbarSettings">
                                    <div class="list-checbox donation-checkbox designation-checkbox"
                                         style="cursor: pointer"
                                         :key="item.designation_id"
                                         v-for="item in displayDesignations"

                                    >
                                        <div class="checkbox-item pl-5 pr-5" @click="selectItem(item.designation_id)">
                                            <label class="checkbox-custom position-relative">
                                                <input type="checkbox" :class="{'checked': itemSelect[item.designation_id]}" disabled>
                                                <span class="checkmark-new" :class="{'not-active': !itemSelect[item.designation_id]}"></span>
                                            </label>
                                            <p :class="{'active': itemSelect[item.designation_id]}" v-text="item.name"></p>
                                        </div>
                                    </div>
                                    </vue-custom-scrollbar>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-2">
                                    <button v-text="'Add'"
                                            class="btn-dialog btn-sm ok-btn" @click="add">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import DibbleJs from "@/dibble";
import DibbleApi from "@/api";
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
    name: "ModalAddCampaignDesignation",
    components: { vueCustomScrollbar },
    props: {
        items: Array,
    },
    data() {
        return {
            search: "",
            itemSelect: {},
            designations: [],
            displayDesignations: [],
            modalScrollbarSettings: {
                maxScrollbarLength: 350,
                wheelPropagation: false
            },
        };
    },
    created() {
        this.getDesignations();
    },
    methods: {
        filter() {
            if (this.search === "") {
                this.displayDesignations = this.designations;
                return;
            }
            this.displayDesignations = this.designations.filter((item) => {
                return item.name.toLowerCase().includes(this.search.toLowerCase());
            });
        },
        getDesignations() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.designationGetAllUnPaged,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.designations = this.displayDesignations = response.designations;

                    if (this.designations.length > 0) {
                        this.designations.forEach((item) => {
                            this.itemSelect[item.designation_id] = false;
                        });
                    }

                    if (this.items.length > 0) {
                        this.items.forEach((item) => {
                            this.itemSelect[item.designation_id] = true;
                        });
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        selectItem(id) {
            const items = this.itemSelect;
            items[id] = !items[id];

            this.itemSelect = []
            this.itemSelect = items;
        },
        closeModal() {
            this.$emit("close");
        },
        add() {
            const selectedItems = this.designations.filter((item) => {
                return this.itemSelect[item.designation_id];
            });

            this.$emit("add", selectedItems);
        }
    },
};
</script>

<style lang="scss" scoped>
.scroll-area {
    position: relative;
    margin: auto;
    height: auto;
    max-height: calc(100vh - 120px);
    overflow: auto;
}
.scroll-area .ps__rail-y { display: none !important; }
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.donation-checkbox {
    .checkbox-item {
        display: flex;
    }

    .checkbox-custom {
        position: inherit;
        width: 40px;
        height: 40px;

        .checkmark-new {
            border-radius: 5px;
            background: #41B8DC;

            &.not-active {
                background: #dde6e9;
            }
        }
    }

    p {
        color: #555E67;
    }
}
.checkbox-custom input.checked~.checkmark-new:after {
    display: block;
}
.input-search {
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 10px;
    width: 85%;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 10px 20px;
    gap: 10px;
    border-radius: 100px;
    user-select: none;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);

    input {
        border: none !important;
        background: #fff;
        font-family: 'Open Sans';
        font-style: normal;
        font-size: 16px;
        width: 80%;

        &:focus {
            outline: none;
        }

        &::placeholder {
            display: block;
            color: #969FA2;
            visibility: visible;
        }
    }
}
.designation-checkbox p {
    font-size: 18px !important;
    color: #555E67 !important;
}
</style>

<style lang="scss">
.modal-campaign-designation {
    .ps__rail-y {
        display: none !important;
    }
}
</style>
